import I18n from 'I18n';
import { AREA, COLUMN, LINE } from 'reporting-data/constants/chartTypes';
// @ts-expect-error Untyped module
import AreaChartIcon from 'reporting-ui-components/components/shared/icons/AreaChartIcon';
// @ts-expect-error Untyped module
import ColumnChartIcon from 'reporting-ui-components/components/shared/icons/ColumnChartIcon';
// @ts-expect-error Untyped module
import LineChartIcon from 'reporting-ui-components/components/shared/icons/LineChartIcon';
import { AVG, PERCENTILES, SUM } from 'reporting-data/constants/metricTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const SECONDARY_METRIC_TYPES = [AVG, PERCENTILES];
export const isSecondaryMetric = metric => {
  const metricType = metric && metric.metricTypes ? metric.metricTypes[0] : SUM;
  return SECONDARY_METRIC_TYPES.includes(metricType);
};
export const getValidatedMetricsToDisplay = (metricsToDisplay, allMetricsData) => metricsToDisplay.filter(m => m in allMetricsData);
export const getChartStyleOptions = (metric, isUngatedForCMPTrellisMigration = false) => {
  if (isUngatedForCMPTrellisMigration) {
    return [{
      indicator: /*#__PURE__*/_jsx(AreaChartIcon, {}),
      disabled: isSecondaryMetric(metric),
      text: I18n.text('content-management-details-lib.reporting.chartStyleOptions.area'),
      value: AREA
    }, {
      indicator: /*#__PURE__*/_jsx(ColumnChartIcon, {}),
      disabled: isSecondaryMetric(metric),
      text: I18n.text('content-management-details-lib.reporting.chartStyleOptions.column'),
      value: COLUMN
    }, {
      indicator: /*#__PURE__*/_jsx(LineChartIcon, {}),
      text: I18n.text('content-management-details-lib.reporting.chartStyleOptions.line'),
      value: LINE
    }];
  }
  return [{
    avatar: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(AreaChartIcon, {})
    }),
    disabled: isSecondaryMetric(metric),
    text: I18n.text('content-management-details-lib.reporting.chartStyleOptions.area'),
    value: AREA
  }, {
    avatar: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(ColumnChartIcon, {})
    }),
    disabled: isSecondaryMetric(metric),
    text: I18n.text('content-management-details-lib.reporting.chartStyleOptions.column'),
    value: COLUMN
  }, {
    avatar: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(LineChartIcon, {})
    }),
    text: I18n.text('content-management-details-lib.reporting.chartStyleOptions.line'),
    value: LINE
  }];
};